<template>
  <div class="main-cn">
      <div class="main-bd mg20">
          <el-tabs v-model="active_name" @tab-click="handleClick">
              <el-tab-pane v-for="(item, key) in active_list" :key="key" :label="item.label" :name="item.value"></el-tab-pane>
          </el-tabs>
          <Conversion v-if="active_name == 'conversion'"></Conversion>
          <Allocation v-else-if="active_name == 'allocation'"></Allocation>
          <Analyze v-else-if="active_name == 'sale-analyze'"></Analyze>
          <Unbind  v-else-if="active_name == 'unbind-list'"></Unbind>
      </div>
  </div>
</template>
<style scoped>

</style>
<script>
import Conversion from "~/views/count/clue/conversion.vue";
import Allocation from "~/views/count/clue/allocation.vue";
import Analyze from "~/views/count/clue/analyze.vue";
import Unbind from "~/views/count/clue/unbind.vue";
export default {
  name: "clueanalysis",

  components: {
    Conversion,
    Allocation,
    Analyze,
    Unbind
  },

  props: {
      
  },
  
  data() {
      return {
        active_name: 'conversion',
        active_list: [
          {
            label: '线索转化分析',
            value: 'conversion',
          },
          {
            label: '线索分配统计',
            value: 'allocation',
          },
          {
            label: '线索统计',
            value: 'sale-analyze',
          },
          // {
          //   label: '线索地区分布',
          //   value: 'map-chart',
          // },
          {
            label: '线索解绑统计',
            value: 'unbind-list',
          },
        ],
      };
  },

  mounted() {

  },

  created() {
    //接口权限校验，没有则不展示对应的子菜单
    this.active_list = this.active_list.filter(item=>{
      if(!this.Acs('/sales-leads-count/' + item.value)){
        return false;
      }else if(!this.active_name){
        this.active_name = item.value;
      }
      return true;
    })
  },

  methods: {
      handleClick(tab, event) {

      },

      handleFinishClick(tab, event){

      },

      handleGoalClick(tab, event){

      },

      // 查看
      handleView(query) {
          let routeData = this.$router.resolve({
              path: query.path,
              query: query,
          });
          window.open(routeData.href, '_blank');
      },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/count/clueanalysis.vue